module.exports = __webpack_public_path__ + "static/media/IZScreen Shot 2022-05-25 at 10.38.35 AM.5d0e7151.png";